module.exports = __webpack_public_path__ + "img/percent.9f51c066.svg";